import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";
import "rxjs/add/operator/mergeMap";
import "rxjs/add/observable/of";
import "rxjs/add/operator/switchMap";
import { concat as concat$ } from "rxjs/observable/concat";
import { from as from$ } from "rxjs/observable/from";
import { of as of$ } from "rxjs/observable/of";
import * as CreDtos from "../CRE.dtos";
import { forumApi } from "../services/forum";


import {

  SEARCH_RESOURCE_REQUEST,
  searchResourceSuccess,
  searchResourceFailure,
  
  SAVE_RESOURCE_REQUEST,
  FLAG_RESOURCE_REQUEST,
  saveResourceSuccess,
  saveResourceFailure,

  ADD_REMOVE_TAG_REQUEST,
  saveResourceTagSuccess,
  saveResourceTagFailure,
  SORT_RESOURCE_SUCCESS,
  sortResourceSuccess,
  sortResourceFailure,
  SORT_RESOURCE_REQUEST,
  
  } from "../actions/resources.actions";

  import {
      siteDataRequest
  } from "../actions/sitedata.actions";


  export const saveResouceEpic = action$ =>
  action$
    .ofType(SAVE_RESOURCE_REQUEST)
    .mergeMap(action =>
      forumApi
        .saveResource(action.id, action.resource)
        .map(response => saveResourceSuccess(response))
        .catch(error =>
          Observable.of(saveResourceFailure(error.responseStatus))
        )
    );

export const flagResouceEpic = action$ =>
  action$
    .ofType(FLAG_RESOURCE_REQUEST)
    .mergeMap(action =>
      forumApi
        .flagResource(action.id, action.resourceId)
        .map(response => saveResourceSuccess(response))
        .catch(error =>
          Observable.of(saveResourceFailure(error.responseStatus))
        )
    );

  export const searchResourceEpic = action$ =>
    action$
      .ofType(SEARCH_RESOURCE_REQUEST)
      .mergeMap(action =>
        forumApi
          .searchResources(action.id, action.term)
          .map(response => searchResourceSuccess(response))
          .catch(error =>
            Observable.of(searchResourceFailure(error.responseStatus))
          )
      );    

  export const saveResourceTagEpic = action$ =>
      action$
        .ofType(ADD_REMOVE_TAG_REQUEST)
        .mergeMap(action =>
          forumApi
            .saveResourceTag(action.tagId, action.resourceId)
            .map(response => saveResourceTagSuccess(response))
            .catch(error =>
              Observable.of(saveResourceTagFailure(error.responseStatus))
            )
        );

export const sortResourceEpic = action$ =>
        action$
          .ofType(SORT_RESOURCE_REQUEST)
          .mergeMap(action =>
            forumApi
              .sortResourceItem(action.forumId, action.resourceId, action.newIndex)
              .map(response => searchResourceSuccess(response))
              .catch(error =>
                Observable.of(sortResourceFailure(error.responseStatus))
              )
          );


// WEBPACK FOOTER //
// ./src/epics/resources.epic.ts